module.exports = __webpack_public_path__ + "f9e5a6a320287326f295f4b9698ae7e3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/LiveChat.ttf
// module id = 334
// module chunks = 0